import { QueryClient } from 'react-query';

// Create a client with aggressive caching and no retries
// Export this so it can be cleared on logout/login to prevent data leakage between user sessions
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false, // Disable all retries
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      staleTime: 10 * 60 * 1000, // 10 minutes
      cacheTime: 30 * 60 * 1000, // 30 minutes
      refetchInterval: false,
      refetchIntervalInBackground: false,
    },
  },
});

